// src/pages/ThankYou.js
import React from "react";
import "../styles/ThankYou.css";

const ThankYou = () => {
  return (
    <div className="thankyou-container">
      <div className="thankyou-card">
        <img src="/hotels.png" alt="Hotel Logo" className="thankyou-logo" />
        <h1 className="thankyou-title">Thank You for Your Feedback!</h1>
        <p className="thankyou-text">
          We appreciate your time and effort in helping us improve our service.
        </p>
        <h2 className="thankyou-link-heading">
          <a
            href="https://www.centauriaresorts.com"
            target="_blank"
            rel="noreferrer"
            className="thankyou-link"
          >
            www.centauriaresorts.com
          </a>
        </h2>
      </div>
    </div>
  );
};

export default ThankYou;
